import { render, staticRenderFns } from "./SendEmailForBirthdaysModal.vue?vue&type=template&id=3837e958&scoped=true"
import script from "./SendEmailForBirthdaysModal.vue?vue&type=script&lang=js"
export * from "./SendEmailForBirthdaysModal.vue?vue&type=script&lang=js"
import style0 from "./SendEmailForBirthdaysModal.vue?vue&type=style&index=0&id=3837e958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3837e958",
  null
  
)

export default component.exports